import "react-app-polyfill/ie11";
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.css';
import '../src/Assets/yoonit.css'
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import './i18n';
import { CheckBrowserType } from './Helpers/BrowserHelper';
import BrowserNotSuported from './BrowserNotSuported';
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./redux/store";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);


//if (CheckBrowserType() !== 'IE') {
//    //appInsights.loadAppInsights();
//    ReactDOM.render(<App />, document.getElementById("root"));
if (CheckBrowserType() !== 'IE') {
    ReactDOM.render(
        <Provider store={store}>
            <PersistGate
                persistor={persistor}>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </PersistGate>
        </Provider>,
        document.getElementById('root'));

}
else
    ReactDOM.render(<BrowserNotSuported />, document.getElementById("root"));